import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { ColumnConfigEx, ColumnDefinitionEx } from "../../../../@core/types/column-config-types-extended";
import { applySearchRule } from '../../../../@core/utils/search-input-helper';
import { Address, DiscountGroupCustomerRelation, DiscountGroupCustomerRelationSearchInput, Operator } from "../../../../generated/generated-types";
import { BaseListWrapperComponent } from '../../../../shared/components/base-list-wrapper/base-list-wrapper.component';
import { NewBaseListComponent } from "../../../../shared/components/new-base-list-component/new-base-list-component";
import { AddressDropDownComponent } from "../../../crm/modules/company-drop-down/company-drop-down/address-drop-down.component";
import { DiscountGroupCustomerRelationService } from "../../services/discount-group-customer-relation.service";

@Component({
  selector: 'app-discount-group-customer-relation-widget',
  template: `<app-base-list-wrapper [baseListComponent]="this" />`,
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    BaseListWrapperComponent
  ]
})
export class DiscountGroupCustomerRelationWidgetComponent extends NewBaseListComponent<DiscountGroupCustomerRelation> {

  discountGroupId = input<string>();

  constructor(
    discountGroupCustomerRelationService: DiscountGroupCustomerRelationService,
  ) {
    super("DiscountGroupCustomerRelation", discountGroupCustomerRelationService);

    this.addInDetail = false;
    this.noCopy = true;
    this.noBaseEdit = true;
    this.inlineEditMode = true;
  }

  override getSearchInputForQuery(): DiscountGroupCustomerRelationSearchInput {
    let si: DiscountGroupCustomerRelationSearchInput = super.getSearchInputForQuery();

    applySearchRule(si, {
      field: "discountGroupId",
      operator: Operator.equal,
      value: this.discountGroupId()
    });

    return si;
  }

  protected override setColumnConfig(colConfig: ColumnConfigEx): void {
    let col: ColumnDefinitionEx = colConfig.columns.find(x => x.field === 'customer.name' || (x.prop === "name" && x.entityType === 'Address'));
    if (col) {
      col.getEditComponent = () => AddressDropDownComponent;
      col.editComponentCreated = async (c: AddressDropDownComponent, rowData: any, _colDef: ColumnDefinitionEx) => {
        if (rowData?.customer)
          c.setModel(rowData.customer);
        else if (rowData?.customerId) {
          await c.loadItemByIdAndSetSelected(rowData.customerId);
          this.cdRef.detectChanges();
        }

        c.value.subscribe((x) => {
          rowData.customerId = (x as Address)?.id;
        });
      }
    }

    super.setColumnConfig(colConfig);
  }

  override saveInCRUDService(rowData: DiscountGroupCustomerRelation): Promise<DiscountGroupCustomerRelation> {
    return super.saveInCRUDService({ ...rowData, discountGroupId: this.discountGroupId() });
  }

}
